module.exports = __webpack_public_path__ + "static/media/Nicotine.f8c7248c.png";